import Vue from "vue";
import VueI18n from "vue-i18n";

// Localisation language list
import { locale as english } from "@/core/config/i18n/en";
import { locale as ch } from "@/core/config/i18n/ch";
import { locale as spanish } from "@/core/config/i18n/es";
import { locale as japan } from "@/core/config/i18n/jp";
import { locale as german } from "@/core/config/i18n/de";
import { locale as france } from "@/core/config/i18n/fr";
import { locale as turkish } from "@/core/config/i18n/tr";
import { locale as italian } from "@/core/config/i18n/it";
import { iconCategoryTranslations } from "@/core/config/i18n/iconCategories";

Vue.use(VueI18n);

let messages = {};
messages = { ...messages, english, ch, spanish, japan, german, france, turkish, italian };

Object.entries(iconCategoryTranslations).forEach(([localeKey, translations]) => {
  messages[localeKey] = { ...(messages[localeKey] || {}), ...translations };
});

// get current selected language
const lang = localStorage.getItem("language") || "turkish";

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
});
window.i18n = i18n;

export default i18n;
